import { dataFetcher, fileUploader } from 'core/services/requestHandler';   

const getCities = async (data = {}, config = {}) => {
  return dataFetcher('libraries/getCities', data, {...config});
};

const getStates = async (data = {}, config = {}) => {
  return dataFetcher('libraries/getStates', data, {...config});
};

const getLibrariesPendingApproval = async (data = {}, config = {}) => {
  return dataFetcher('libraries/getLibrariesPendingApproval', data, { ...config});
};

const deleteLibraryFromStage = async (data = {}, config = {}) => {
  return dataFetcher('libraries/deleteLibraryFromStage', data, { ...config});
};

const getLiveAndStagedLibraryById = async (data = {}, config = {}) => {
  return dataFetcher('libraries/getLiveAndStagedLibraryById', data, { ...config});
};

const getLibraryPhotoNames = async (data = {}, config = {}) => {
  return dataFetcher('libraries/getLibraryPhotoNames', data, { ...config});
};

const saveLibraryCoverPhoto = async (data = {}, config = {}) => {
  return fileUploader('libraries/saveLibraryCoverPhoto', data, { method: 'POST', ...config});
};

const uploadLibraryPhoto = async (data = {}, config = {}) => {
  return fileUploader('libraries/uploadLibraryPhoto', data, { method: 'POST', ...config});
};

const deleteLibraryPhoto = async (data = {}, config = {}) => {
  return dataFetcher('libraries/deleteLibraryPhoto', data, { method: 'POST', ...config});
};

//admin

const approveLibrary = async (data = {}, config = {}) => {
  return dataFetcher('libraries/approveLibrary', data, {...config});
};
const rejectLibrary = async (data = {}, config = {}) => {
  return dataFetcher('libraries/rejectLibrary', data, {method: 'POST', ...config});
};

const saveAndApproveLibrary = async (data = {}, config = {}) => {
  return dataFetcher('libraries/saveAndApproveLibrary', data, { method: 'POST', ...config});
};

const getLibraries = async (data = {}, config = {}) => {
  return dataFetcher('libraries/getLibraries', data, { ...config});
};

const deleteLibrary = async (data = {}, config = {}) => {
  return dataFetcher('libraries/deleteLibrary', data, { ...config});
};

const getLibraryDetails = async (data = {}, config = {}) => {
  return dataFetcher('libraries/getLibraryData', data, { ...config});
};

const updateLibrary = async (data = {}, config = {}) => {
  return dataFetcher('libraries/updateLibrary', data, {method: 'POST', ...config});
};

const saveLibraryType = async (data = {}, config = {}) => {
  return dataFetcher('libraries/saveLibraryType', data, {...config});
};

const getLibraryTypes = async (data = {}, config = {}) => {
  return dataFetcher('libraries/getLibraryTypes', data, {...config});
};

const deleteLibraryType = async (data = {}, config = {}) => {
  return dataFetcher('libraries/deleteLibraryType', data, {...config});
};

const getPropertiesByOwner = async (data = {}, config = {}) => {
  return dataFetcher('properties/getPropertiesByOwner', data, {...config});
};

const getBankNames = async (data = {}, config = {}) => {
  return dataFetcher('libraries/getBankNames', data, {...config});
};

const getVendorKYCStatus = async (data = {}, config = {}) => {
  return dataFetcher('users/getVendorKYCStatus', data, {...config});
};

const getVendorIdType = async (data = {}, config = {}, userId) => {
  return dataFetcher(`users/${userId}/getVendorIdType`, data, {...config});
};

const deleteVendorIDImage = async (data = {}, config = {}, customData={}) => {
  const {userId, type} = customData;
  return dataFetcher(`users/id/${userId}/${type}`, data, {method: 'DELETE', ...config});
};

const saveVendorBankDetails = async (data = {}, config = {}) => {
  return dataFetcher('users/saveVendorBankDetails', data, {method: 'POST', ...config});
};

const updateVendorBankDetails = async (data = {}, config = {}) => {
  return dataFetcher('users/updateVendorBankDetails', data, {method: 'POST', ...config});
};

const saveVendorIDImage = async (data = {}, config = {}, customData={}) => {
  const {userId, type} = customData;
  return fileUploader(`users/id/${userId}/${type}`, data, {method: 'POST', ...config});
};

const getLibraryPhotoNamesFromStage = async (data = {}, config = {}) => {
  return dataFetcher('libraries/getLibraryPhotoNamesFromStage', data, { ...config});
};

const saveLibraryPosterImage = async (data = {}, config = {}) => {
  return fileUploader('libraries/saveLibraryPosterImage', data, { method: 'POST', ...config});
};

const getAmenities = async (data = {}, config = {}) => {
  return dataFetcher('libraries/getAmenities', data, {...config});
};

export { getCities, getStates, updateLibrary, getLibrariesPendingApproval, deleteLibrary, deleteLibraryFromStage, 
  getLibraryDetails, getLiveAndStagedLibraryById, saveLibraryCoverPhoto, uploadLibraryPhoto, getLibraryPhotoNames,
  deleteLibraryPhoto, getLibraries, saveAndApproveLibrary, rejectLibrary, approveLibrary, getLibraryTypes, saveLibraryType,
  deleteLibraryType, getPropertiesByOwner, getVendorKYCStatus, getVendorIdType, deleteVendorIDImage, saveVendorBankDetails,
  updateVendorBankDetails, saveVendorIDImage, getBankNames, getLibraryPhotoNamesFromStage, saveLibraryPosterImage,
  getAmenities
};
